import { URL_MAX_LENGTH } from 'constants/validationConstants'
import { RhcField } from 'features/generator/components/RhcField'
import { useTranslations } from 'next-intl'
import { useFormContext } from 'react-hook-form'
import { maxLength } from 'utils/inputChangeUtils'

import { addressUrlAtom } from '../addressAtoms'
import { TAddressFields } from '../addressSchema'

export const UrlAddressField = () => {
	const t = useTranslations()

	const form = useFormContext<TAddressFields>()

	return (
		<RhcField
			type="url"
			form={form}
			path="address.url"
			fieldName="address_url"
			atom={addressUrlAtom}
			label={t(
				'generator__content_form_section__about__address_section__url',
			)}
			placeholder={t(
				'generator__content_form_section__about__address_section__url__placeholder',
			)}
			className="col-span-2"
			onChangeTransform={(event) => maxLength(URL_MAX_LENGTH + 1)(event)}
		/>
	)
}
